import React, { useCallback, useEffect, useState } from "react";
import baseUrl from "../../../api/baseUrl";
import BottomTab from "../../../components/pagination/BottomTab";
import EventIcon from "@mui/icons-material/Event";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

function UpcommingTable() {
  const [appointments, setappointments] = useState([]);
  const [count, setcount] = useState(0);
  const [page, setpage] = useState(1);

  const getdata = useCallback((pages: any) => {
    baseUrl
      .get("dashboard/upcommingAppointment", {
        headers: { page: pages },
      })
      .then((response) => {
        console.log(response.data.data);
        
        setappointments(response.data.data);
        setcount(response.data.count);
      })
      .catch((error) => {
        console.error(error.response);
      });
  }, []);

  useEffect(() => {
    getdata(page);
  }, [page, getdata]);

  const onPageChange = (e: any) => {
    getdata(e);
    setpage(e);
  };

  return (
    <div className="rounded-2xl shadow-lg border overflow-hidden transition-all duration-300 bg-white border-slate-100 shadow-slate-200/50 dark:bg-slate-800 dark:border-slate-700 dark:shadow-slate-900/50">
      {/* Header */}
      <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-700 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-primary to-primaryLight rounded-xl flex items-center justify-center">
            <EventIcon className="text-white" sx={{ fontSize: 20 }} />
          </div>
          <h3 className="text-lg font-bold text-slate-800 dark:text-slate-100">Upcoming Appointments</h3>
        </div>
        <span className="px-3 py-1 rounded-full text-sm font-medium bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-300 dark:border dark:border-indigo-800/50">
          {count} Total
        </span>
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden p-4 space-y-3">
        {appointments?.length === 0 ? (
          <div className="text-center py-8 text-slate-400 dark:text-slate-500">
            <EventIcon sx={{ fontSize: 48 }} className="mb-2" />
            <p>No upcoming appointments</p>
          </div>
        ) : (
          appointments?.map((item: any, index: number) => (
            <div
              key={index}
              className="rounded-xl p-4 border bg-slate-50 border-slate-100 dark:bg-slate-700/50 dark:border-slate-600"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 bg-gradient-to-br from-primary to-primaryLight rounded-full flex items-center justify-center text-white font-semibold text-sm">
                    {item?.patientId?.fullName?.charAt(0)?.toUpperCase()}
                    {item?.bookPatientId?.fullName?.charAt(0)?.toUpperCase()}
                  </div>
                  <div>
                    <p className="font-semibold text-slate-800 dark:text-slate-100">
                      {item?.patientId?.fullName}
                      {item?.bookPatientId?.fullName}
                    </p>
                    <p className="text-xs text-slate-500 dark:text-slate-400">
                      {item?.doctorId?.firstName} {item?.doctorId?.lastName}
                    </p>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 text-sm text-slate-600 dark:text-slate-300">
                <div className="flex items-center gap-2">
                  <EventIcon sx={{ fontSize: 16 }} className="text-slate-400 dark:text-slate-500" />
                  <span>{item?.date?.split("T")[0]}</span>
                </div>
                <div className="flex items-center gap-2">
                  <AccessTimeIcon sx={{ fontSize: 16 }} className="text-slate-400 dark:text-slate-500" />
                  <span>{item?.startTime}</span>
                </div>
                <div className="flex items-center gap-2 col-span-2">
                  <PhoneIcon sx={{ fontSize: 16 }} className="text-slate-400 dark:text-slate-500" />
                  <span>{item?.patientId?.mobileNo} </span>
                  <span>{item?.bookPatientId?.phoneNumber}</span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Desktop Table */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50/80 dark:bg-slate-700/50">
              <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                <div className="flex items-center gap-2">
                  <PersonIcon sx={{ fontSize: 16 }} />
                  Patient Name
                </div>
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                <div className="flex items-center gap-2">
                  <EventIcon sx={{ fontSize: 16 }} />
                  Date
                </div>
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                <div className="flex items-center gap-2">
                  <AccessTimeIcon sx={{ fontSize: 16 }} />
                  Time
                </div>
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                <div className="flex items-center gap-2">
                  <PhoneIcon sx={{ fontSize: 16 }} />
                  Contact
                </div>
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                <div className="flex items-center gap-2">
                  <EventIcon sx={{ fontSize: 16 }} />
                  Type
                </div>
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                <div className="flex items-center gap-2">
                  <LocalHospitalIcon sx={{ fontSize: 16 }} />
                  Dentist
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 dark:divide-slate-700">
            {appointments?.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-6 py-12 text-center text-slate-400 dark:text-slate-500">
                  <EventIcon sx={{ fontSize: 48 }} className="mb-2" />
                  <p>No upcoming appointments</p>
                </td>
              </tr>
            ) : (
              appointments?.map((item: any, index: number) => (
                <tr key={index} className="transition-colors hover:bg-slate-50/50 dark:hover:bg-slate-700/50">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 bg-gradient-to-br from-primary to-primaryLight rounded-full flex items-center justify-center text-white font-semibold text-sm">
                        {item?.patientId?.fullName?.charAt(0)?.toUpperCase()}
                        {item?.bookPatientId?.fullName?.charAt(0)?.toUpperCase()}
                      </div>
                      <span className="font-medium text-slate-800 dark:text-slate-200">
                        {item?.patientId?.fullName}
                        {item?.bookPatientId?.fullName}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600 dark:text-slate-300">
                    {item?.date?.split("T")[0]}
                  </td>
                  <td className="px-6 py-4">
                    <span className="px-2.5 py-1 rounded-lg text-sm font-medium bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-300 dark:border dark:border-indigo-800/50">
                      {item?.startTime}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600 dark:text-slate-300">
                    {item?.patientId?.mobileNo}
                    {item?.bookPatientId?.phoneNumber}
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600 dark:text-slate-300">
                      {item?.type}
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600 dark:text-slate-300">
                    Dr. {item?.doctorId?.firstName} {item?.doctorId?.lastName}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="border-t border-slate-100 dark:border-slate-700">
        <BottomTab title={"Appointments"} count={count} onPageChange={onPageChange} />
      </div>
    </div>
  );
}

export default UpcommingTable;
